
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireebe9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireebe9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ihIr4", function(module, exports) {

$parcel$export(module.exports, "RegistrationForm", () => $8c57391d58310641$export$dd257f81ed04ccc5);
parcelRequire("6tisJ");
var $iOr0X = parcelRequire("iOr0X");
function $8c57391d58310641$export$63cc8fd78499889d(event, user) {
    const form = /*#__PURE__*/ (0, $iOr0X.jsx)("form", {
        action: "https://secure.tpay.com/",
        method: "post",
        name: "payment",
        children: [
            /*#__PURE__*/ (0, $iOr0X.jsx)("input", {
                name: "id",
                value: "143381",
                type: "hidden"
            }),
            /*#__PURE__*/ (0, $iOr0X.jsx)("input", {
                name: "kwota",
                value: "40",
                type: "hidden"
            }),
            /*#__PURE__*/ (0, $iOr0X.jsx)("input", {
                name: "md5sum",
                value: "e116003b7c1e6614ad27aad658180901",
                type: "hidden"
            }),
            /*#__PURE__*/ (0, $iOr0X.jsx)("input", {
                name: "email",
                value: user.email,
                type: "hidden"
            }),
            /*#__PURE__*/ (0, $iOr0X.jsx)("input", {
                name: "nazwisko",
                value: user.name,
                type: "hidden"
            }),
            /*#__PURE__*/ (0, $iOr0X.jsx)("input", {
                name: "opis",
                value: "darowizna na " + event.bookero_service_name,
                type: "hidden"
            }),
            /*#__PURE__*/ (0, $iOr0X.jsx)("input", {
                name: "jezyk",
                value: "PL",
                type: "hidden"
            }),
            /*#__PURE__*/ (0, $iOr0X.jsx)("button", {
                type: "submit",
                children: [
                    "Przeka\u017C darowizn\u0119 40 z\u0142",
                    /*#__PURE__*/ (0, $iOr0X.jsx)("br", {}),
                    "na organizacj\u0119 biegu"
                ]
            }),
            /*#__PURE__*/ (0, $iOr0X.jsx)("p", {
                children: [
                    "Ewentualny nadmiar \u015Brodk\xf3w zostanie przeznaczony na inne cele po\u017Cytku publicznego realizowane przez stowarzyszenie Homokomando. Darowizny na Homokomando mo\u017Cna odliczy\u0107 od podatku. ",
                    /*#__PURE__*/ (0, $iOr0X.jsx)("a", {
                        href: "../wspieraj.html",
                        children: "Wi\u0119cej informacji o darowiznach na Homokomando."
                    })
                ]
            })
        ]
    });
    form.addEventListener("submit", ()=>{
        try {
            fbq("track", "Donate");
        } catch (e) {
            console.log(e);
        }
    });
    return form;
}
function $8c57391d58310641$export$dd257f81ed04ccc5(event) {
    const form = /*#__PURE__*/ (0, $iOr0X.jsx)("form", {
        id: "zapisy",
        children: [
            /*#__PURE__*/ (0, $iOr0X.jsx)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, $iOr0X.jsx)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $iOr0X.jsx)("label", {
                                for: "input-name",
                                children: [
                                    /*#__PURE__*/ (0, $iOr0X.jsx)("strong", {
                                        children: "Imi\u0119 i nazwisko"
                                    }),
                                    " (wybrane przez Ciebie)"
                                ]
                            }),
                            /*#__PURE__*/ (0, $iOr0X.jsx)("input", {
                                type: "text",
                                name: "name",
                                id: "input-name",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iOr0X.jsx)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $iOr0X.jsx)("label", {
                                for: "input-email",
                                children: /*#__PURE__*/ (0, $iOr0X.jsx)("strong", {
                                    children: "Adres e-mail"
                                })
                            }),
                            /*#__PURE__*/ (0, $iOr0X.jsx)("input", {
                                type: "email",
                                name: "email",
                                id: "input-email",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iOr0X.jsx)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $iOr0X.jsx)("label", {
                                for: "input-phone",
                                children: /*#__PURE__*/ (0, $iOr0X.jsx)("strong", {
                                    children: "Numer telefonu"
                                })
                            }),
                            /*#__PURE__*/ (0, $iOr0X.jsx)("input", {
                                type: "tel",
                                name: "phone",
                                id: "input-phone",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iOr0X.jsx)("dl", {
                        children: [
                            /*#__PURE__*/ (0, $iOr0X.jsx)("dt", {
                                children: "Cel przetwarzania:"
                            }),
                            /*#__PURE__*/ (0, $iOr0X.jsx)("dd", {
                                children: "Przeprowadzenie biegu, zapewnienie bezpiecze\u0144stwa, informowanie o ewentualnych zmianach"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iOr0X.jsx)("dl", {
                        children: [
                            /*#__PURE__*/ (0, $iOr0X.jsx)("dt", {
                                children: "Podstawa przetwarzania:"
                            }),
                            /*#__PURE__*/ (0, $iOr0X.jsx)("dd", {
                                children: "Niezb\u0119dne do wykonania umowy (art. 6 (1) (b) RODO)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iOr0X.jsx)("dl", {
                        children: [
                            /*#__PURE__*/ (0, $iOr0X.jsx)("dt", {
                                children: "Czas przetwarzania:"
                            }),
                            /*#__PURE__*/ (0, $iOr0X.jsx)("dd", {
                                children: "Do 7 dni po zako\u0144czeniu wydarzenia"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iOr0X.jsx)("div", {
                children: [
                    /*#__PURE__*/ (0, $iOr0X.jsx)("dl", {
                        children: [
                            /*#__PURE__*/ (0, $iOr0X.jsx)("dt", {
                                children: "Administrator danych:"
                            }),
                            /*#__PURE__*/ (0, $iOr0X.jsx)("dd", {
                                children: [
                                    "Stowarzyszenie Homokomando, ",
                                    /*#__PURE__*/ (0, $iOr0X.jsx)("a", {
                                        href: "mailto:zarzad@homokomando.pl",
                                        children: "zarzad@homokomando.pl"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iOr0X.jsx)("dl", {
                        children: [
                            /*#__PURE__*/ (0, $iOr0X.jsx)("dt", {
                                children: "Twoje prawa:"
                            }),
                            /*#__PURE__*/ (0, $iOr0X.jsx)("dd", {
                                children: "Masz prawo dost\u0119pu do swoich danych, ich sprostowania, usuni\u0119cia lub ograniczenia przetwarzania; a tak\u017Ce do wniesienia skargi do UODO."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iOr0X.jsx)("button", {
                type: "submit",
                children: "Zapisz si\u0119"
            })
        ]
    });
    form.addEventListener("submit", async (e)=>{
        e.stopPropagation();
        e.preventDefault();
        const submitButton = form.querySelector('button[type="submit"]');
        const data = new FormData(form);
        const userData = {
            name: data.get("name"),
            email: data.get("email"),
            phone: data.get("phone")
        };
        const signUpForNewsletter = data.get("newsletter") === "on";
        for (const fieldset of form.getElementsByTagName("fieldset"))fieldset.disabled = true;
        for (const button of form.getElementsByTagName("button"))button.disabled = true;
        form.classList.add("disabled");
        const plugin_comment = {
            data: {
                name: userData.name,
                phone: userData.phone,
                parameters: [],
                services_names: [
                    {
                        category: "Biegi R\xf3wno\u015Bci",
                        value: event.bookero_service_name,
                        require_people: 0
                    }
                ],
                services_values: [
                    {
                        category: 6666,
                        value: event.bookero_service_id,
                        require_people: 0
                    }
                ]
            }
        };
        const body = {
            bookero_id: "VKCIH68TrrM0",
            agree_tp: false,
            agree_newsletter: signUpForNewsletter,
            agree_telemarketing: false,
            discount_code: "",
            configuration_payment_id: 0,
            lang: "pl",
            cart_id: 0,
            name: userData.name,
            phone: userData.phone,
            email: userData.email,
            inquiries: [
                {
                    plugin_comment: JSON.stringify(plugin_comment),
                    phone: userData.phone,
                    people: 1,
                    date: event.date,
                    hour: event.start_time,
                    email: userData.email,
                    service: event.bookero_service_id,
                    worker: 0,
                    periodicity_id: 0,
                    custom_duration_id: 0,
                    plugin_inquiry_id: null
                }
            ]
        };
        let maybeAlreadyRegistered = false;
        try {
            const res = await (await fetch("https://plugin.bookero.pl/plugin-api/v2/add", {
                method: "POST",
                headers: {
                    "accept": "application/json, text/plain, */*",
                    "content-type": "application/json"
                },
                referrerPolicy: "strict-origin",
                mode: "cors",
                credentials: "omit",
                body: JSON.stringify(body)
            })).json();
            if (res.result !== 1) throw new Error();
            if (res.data.inquiries[0].status != 3) {
                if (res.data.inquiries[0].status == 4) maybeAlreadyRegistered = true;
                throw new Error();
            }
        } catch (e) {
            const error = /*#__PURE__*/ (0, $iOr0X.jsx)("p", {
                children: [
                    /*#__PURE__*/ (0, $iOr0X.jsx)("strong", {
                        children: "Wyst\u0105pi\u0142 b\u0142\u0105d."
                    }),
                    maybeAlreadyRegistered ? " Mo\u017Ce ju\u017C wcze\u015Bniej si\u0119 zarejestrowa\u0142a\u015B_e\u015B?" : ""
                ]
            });
            form.parentElement.insertBefore(error, form.nextSibling);
            error.style.opacity = "1";
            error.style.transitionDuration = "5s";
            error.style.transitionProperty = "opacity";
            setTimeout(()=>error.style.opacity = "0", 4000);
            setTimeout(()=>error.remove(), 8000);
            for (const fieldset of form.getElementsByTagName("fieldset"))fieldset.disabled = false;
            for (const button of form.getElementsByTagName("button"))button.disabled = false;
            form.classList.remove("disabled");
            return;
        }
        const afterform = form.nextSibling;
        const thanks = /*#__PURE__*/ (0, $iOr0X.jsx)("p", {
            children: /*#__PURE__*/ (0, $iOr0X.jsx)("strong", {
                children: "Dzi\u0119kujemy! Zosta\u0142a\u015B_e\u015B zapisana_y. Do zobaczenia na biegu!"
            })
        });
        form.parentElement.insertBefore(thanks, afterform);
        const gifmany = /*#__PURE__*/ (0, $iOr0X.jsx)("p", {
            children: [
                /*#__PURE__*/ (0, $iOr0X.jsx)("strong", {
                    children: "Start jest darmowy"
                }),
                ", \u017Ceby nikt nie by\u0142 wykluczony. Organizacja biegu jednak kosztuje, dlatego je\u015Bli chcesz - przeka\u017C nam darowizn\u0119 na organizacj\u0119 biegu, w wysoko\u015Bci 40 z\u0142."
            ]
        });
        form.parentElement.insertBefore(gifmany, afterform);
        const donform = $8c57391d58310641$export$63cc8fd78499889d(event, userData);
        form.parentElement.insertBefore(donform, afterform);
        submitButton.parentElement.removeChild(submitButton);
        thanks.scrollIntoView({
            behavior: "smooth"
        });
        try {
            fbq("track", "CompleteRegistration", {
                content_name: event.bookero_service_name
            });
        } catch (e) {
            console.log(e);
        }
    });
    return form;
}

});
parcelRegister("6tisJ", function(module, exports) {

$parcel$export(module.exports, "jsx", () => (parcelRequire("iOr0X")).jsx);
$parcel$export(module.exports, "jsxs", () => (parcelRequire("iOr0X")).jsx);

var $iOr0X = parcelRequire("iOr0X");

});
parcelRegister("iOr0X", function(module, exports) {

$parcel$export(module.exports, "jsx", () => $008daf44ef63fde8$export$34b9dba7ce09269b);
const $008daf44ef63fde8$var$nameMap = new Map([
    [
        "for",
        "htmlFor"
    ]
]);
function $008daf44ef63fde8$var$isIterable(v) {
    return v != null && v[Symbol.iterator] !== undefined;
}
class $008daf44ef63fde8$var$ClassMultiSet {
    element;
    _classes;
    constructor(element){
        this.element = element;
        this._classes = new Map();
    }
    _change(class_, change) {
        const newCount = (this._classes.get(class_) ?? 0) + change;
        this._classes.set(class_, newCount);
        newCount > 0 ? this.element.classList.add(class_) : this.element.classList.remove(class_);
        return newCount;
    }
    add(class_) {
        this._change(class_, 1);
    }
    remove(class_) {
        this._change(class_, -1);
    }
}
function $008daf44ef63fde8$var$strixElement(e) {
    const e2 = e;
    if (e2.strixClassMultiSet == undefined) e2.strixClassMultiSet = new $008daf44ef63fde8$var$ClassMultiSet(e);
    return e2;
}
const $008daf44ef63fde8$export$dda1d9f60106f0e9 = (type, props, ...children)=>{
    props = props ?? {};
    const e = $008daf44ef63fde8$var$strixElement(document.createElement(type));
    if (props.class !== undefined) // TODO add some indirection, so this won't override class:* attributes.
    e.className = props.class;
    if (props.style !== undefined) {
        if (typeof props.style === "string") // @ts-ignore: it's actually not read-only
        e.style = props.style;
        else for (const [k, v] of Object.entries(props.style))e.style[k] = v;
    }
    for (const [name, value] of Object.entries(props)){
        if (name.startsWith("v-") || name === "class" || name === "style") ;
        else if (name.startsWith("class:") || name.startsWith("class_")) {
            const className = name.substring(6);
            value ? e.classList.add(className) : e.classList.remove(className);
        } else if (name.startsWith("on")) e.addEventListener(name.toLowerCase().substring(2), value);
        else e[$008daf44ef63fde8$var$nameMap.get(name) ?? name] = value;
    }
    for (const child of children){
        const newNodes = (()=>{
            if (child === undefined || child === null) return [];
            else if (child instanceof Set) return child.values();
            else if (child instanceof Map) return child.values();
            else if (child instanceof Node) return [
                child
            ];
            else if (typeof child == "string") return [
                document.createTextNode(child)
            ];
            else if (typeof child == "number") return [
                document.createTextNode(child.toString())
            ];
            else if ($008daf44ef63fde8$var$isIterable(child)) return child;
            else {
                console.log(child);
                throw new Error("Invalid child type");
            }
        })();
        for (const node of newNodes){
            if (node === undefined) continue;
            try {
                e.appendChild(node);
            } catch (e) {
                console.log("CANT APPEND", node, e);
            }
        }
    }
    return e;
};
function $008daf44ef63fde8$export$34b9dba7ce09269b(type, config, maybeKey) {
    const oldConfig = {
        ...config
    };
    delete oldConfig.children;
    // @ts-ignore
    const children = config.children == undefined ? [] : config.children[Symbol.iterator] ? config.children : [
        config.children
    ];
    // @ts-ignore
    return $008daf44ef63fde8$export$dda1d9f60106f0e9(type, oldConfig, ...children);
}
function $008daf44ef63fde8$export$b03b108e02387893(type, config, maybeKey, isStaticChildren, source, self) {
    return $008daf44ef63fde8$export$34b9dba7ce09269b(type, config, maybeKey);
}

});




//# sourceMappingURL=393747e7.js.map
